//module that defines onSite constants

export default {
  PLACEHOLDERS: {"DEFAULT_ANALYTICS_SUBMIT_EVENTS_URL":"https://analytics-fe.digital-cloud.medallia.com/api/web/events","USER_AGENT_CLIENT_HINTS_LIST":"[\"brands\", \"mobile\", \"platform\", \"architecture\", \"model\", \"bitness\", \"platformVersion\", \"fullVersionList\", \"wow64\", \"uaFullVersion\"]","DIGITAL_ANALYTICS_STATIC_EVENTS_LIST":"[\"nebula_eventDispatcherError\", \"MDigital_warning\", \"MDigital_couldNotFetchData\", \"mdigital_noDataMessageDisplayed\", \"nebula_after_http_get_request_on_timeout\", \"nebula_after_http_get_request_on_error\", \"nebula_after_http_get_request_on_error_status_code\"]","ONSITE_DATA_PATH":"resources.digital-cloud.medallia.com/wdcus/155172/onsite/onsiteData1786277260333.json","SUBMIT_URL_PREFIX":"https://feedback.digital-cloud.medallia.com/","JS_SITE_CODE":"resources.digital-cloud.medallia.com/wdcus/155172/onsite/generic1786277260444.js","DEFAULT_MEC_INTEGRATION_ID":"republicservices-sc4-medallia-com-republicservices","USERSNAP_HOST_PREFIX":"//screencapture.kampyle.com/","COOLADATA_API_HOST":"udc-neb.kampyle.com/","COOLADATA_SRC_PREFIX":"https://resources.digital-cloud.medallia.com/","ONSITE_VERSION":"1.71.2","USERSNAP_V4_HOST_PREFIX":"//scp.kampyle.com","URL_PREFIX":"https://resources.digital-cloud.medallia.com/","USERSNAP_ONPREM_HOST_PREFIX":"https://md-scp.kampyle.com/"},
  SRC: {
    OPEN_SANS: 'resources/form/FormBuilder/vendor/fonts-googleapis/css/open-sans-v14.css',
    OOPS: 'resources/onsite/images/oops.svg'
  },
  FORM_HEIGHT: '450',
  FORM_WIDTH: '450',
  COOKIE_EXPIRATION: 365,
  DELAY_BETWEEN_TABS_TRIGGER_MS: 550,
  DEVICES: {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
    TABLET: 'tablet',
  },
  FEATURE_VERSIONS: {
    MOBILE_DYNAMIC_SIZING: 2,
  },
  TIME_FORMATS: {
    SECONDS: 'seconds',
    MINUTES: 'minutes',
    HOURS: 'hours',
    DAYS: 'days',
    WEEKS: 'weeks',
    MONTHS: 'months',
    YEARS: 'years',
  },
  DISPLAY_TYPES: {
    LIGHTBOX: 'lightbox',
    ANIMATION: 'animation',
    POPUP: 'popup',
    EMBEDDED: 'embedded',
  },
  FORM_TYPES: {
    EMBEDDED: 'embedded',
    INVITATION: 'invitation',
    BUTTON: 'button',
    CODE: 'code',
  },
  EVENT_DATA: {
    PAGE_NUMBER: 'pageNumber',
    FEEDBACK_CORRELATION_UUID: 'feedbackCorrelationUUID',
    FEEDBACK_UUID: 'feedbackUUID'
  },
  EVENT_NAME: {
    NEB_LOAD_FORM: 'neb_loadForm'
  },
  FEATURE_FLAGS: {
    WCAG: 'WCAG',
    EXEMPT_BUTTON_FORMS_FROM_QUARANTINE:'exemptButtonFormsFromQuarantine',
    EXEMPT_EMBEDDED_FORMS_FROM_QUARANTINE:'exemptEmbeddedFormsFromQuarantine',
    EXEMPT_CODE_FORMS_FROM_QUARANTINE:'exemptCodeFormsFromQuarantine'
  },
  PROVISIONS: {
    analyticsNewEvents: 'cooladataNewEvents',
    NEW_SCREEN_CAPTURE_CONFIG: 'newScreenCaptureConfiguration',
    ON_PREM_HYBRID: 'onPremHybrid',
    FORM_TEMPLATE_DATA_SEPERATION: 'separateFormTemplateFromData',
    EVENT_INCLUDE_FEEDBACK_CONTENT: 'eventIncludeFeedbackContent',
    CP_EXT_REFACTOR: 'cpExtractRefactor',
    ADOBE_INCLUDE_LINK_TRACK_VARS: 'adobeIncludeLinkTrackVars',
    ADOBE_ANALYTICS_OBJECT_NAME: 'adobeAnalyticsObjectName',
    ADOBE_CONCAT_LINK_TRACK_VARS: 'adobeConcatLinkTrackVars',
    ENABLE_OVERFLOW: 'enableOverflow',
    ENABLE_SPA_OVERFLOW_FIX: '24dcr1_MPC7514_enableSPAOverflowFix',
    SERVER_BASED_TARGETING: 'serverBasedTargeting',
    ANALYTICS_EVNETS_LIMIT: 'cooladataEventsLimit',
    UBT_EXTRA_EVENTS: 'UBTExtraEvents',
    ALTERNATIVE_UUID: 'alternativeUUID',
    DISABLE_COOKIE_STORAGE: 'cookieStorageDisable',
    SHARE_PROPERTY_DOMAIN: 'sharePropertyBetweenSubdomains',
    SKIP_INVITATION_OPTIMIZATION: 'skipInvitationOptimization',
    DO_NOT_SURVEY_ON_UBT_NETWORK_FAIL: 'doNotSurveyOnUBTNetworkFail',
    DHH:'dynamicHybridHosting',
    USER_SNAP_V4: 'userSnapV4',
    DYNAMIC_ONSITE_EVENTS: 'dynamicOnsiteEvents',
    CSP_RULES: 'CSPRemoveInlineStyling',
    CREATE_SESSION:'cooladataCreateSessionEvent',
    FORM_TEMPLATES_WCAG:'formTemplatesWCAG',
    PREVENT_IFRAME_SCROLLBAR_FLICKERING:'20dcr32_NM11146_PreventIFrameScrollFlickering',
    CHTML_LOGS:'chtmlLogs',
    EXEMPT_FORMS_FROM_QUARANTINE:'20dcr4_MPC2952_enable_exemptFormsFromQuarantine',
    USER_SNAP_AS_COMPONENT: '20dcr4_MPC2893_enable_ScreenCaptureAsComponent',
    ADDITIONAL_BUTTON_STYLES: '21dcr1_MPC3199_AdditionalButtonStyles',
    GREATER_SMALLER_THAN_DECODE: '21dcr1_MPC3370_EnableGreaterSmallerThanSupport',
    IS_CHTML_HANDLE_INIT_FOCUS_INDEPENDENTLY: '21dcr3_MPC3281_enable_CHTMLHandleFocusIndependently',
    WCAG_REVIEW_FIXES: '20dcr4_MPC2905_wcagReviewFixes',
    PROPERTY_MESSAGES: 'propertyMessages',
    NOT_SCROLL_TO_LAST_POSITION_DISPLAY_TYPE_ANIMATION :'willNotScrollToLastPositionDisplayTypeAnimation',
    CLEAR_EMBEDDED_ON_UPDATE_PAGE: '21dcr2_MPC3571_enable_ClearEmbeddedFormOnUpdatePageView',
    ENABLE_EVENTS_FOR_CE_DEBUG: '21DCR2_MPC3662_EnableEventsForCEDebug',
    EXPOSE_SELECTION_QUESTIONS:'21DCR3_MPC3866_exposeSelectionQuestionsInCustomEvent',
    EXPOSE_VERBATIM_QUESTIONS:'21DCR3_MPC3866_exposeVerbatimQuestionsInCustomEvent',
    EXTENSION_ENABLED: '21dcr6_MPC4042_enable_exmdextension',
    LIVE_FORM_V2: '21dcr2_MPC2743_enable_newLiveForm',
    ENABLE_FIX_FOR_SPA_TIME_ON_PAGE:'21DCR5_MPC4030_EnableFixForSpaTimeOnPage',
    ENABLE_UBT_IDENTIFIER_HASH: '21dcr6_MPC4296_enable_UBTIdentifierHash',
    TARGETING_EVENTS_REPORTING: 'targetingEventsReporting',
    PARALLEL_TAB_SOLUTION: 'parallelTabSolution',
    UNDERSCORE_LOCALIZATION: 'underScoreLocalization',
    ADD_RANDOM_TIME_FOR_SESSION: 'addingRandomTimeForTimeInSession',
    SPA_URL_POLLING: 'spaUrlPolling',
    ENABLE_WCAG_PREPEND_SURVEY: '23dcr1_MPC6711_enableWCAGPrependSurvey',
    MOBILE_WEB_BANNER_FIX: '23dcr1_mpc6083_enableMobileWebiOSBannerFix',
    ENABLE_ANALYTICS_SESSION_EVENTS: '23dcr2_MPC6869_enableCXJSessionEvents',
    DISABLE_ANALYTICS_NEW_PAGE_EVENTS: '23dcr2_MPC6869_disableNewPageEvents',
    ENABLE_ONSITE_DOMAIN_APPROVAL: '23dcr3_MPC6996_enableOnsiteDomainApproval',
    ENABLE_INVITATION_SPINNER_FIX: '23dcr4_MPC7186_enableInvitationSpinnerFix',
    DECIBEL_INSIGHT: 'decibelInsight',
    ENABLE_VIEWPORT_LOGIC_FIX: '24dcr2_MPC7960_enableViewportLogicFix',
    ENABLE_ONSITE_POST_MESSAGE_VERIFICATION: '24dcr2_MPC7960_enableOnsitePostMessageVerification',
    ENABLE_DYNAMIC_ANALYTICS_EVENTS: '25dc1_MPC8353_enableDynamicAnalyticsEvents',
    ENABLE_NEW_FEEDBACK_SUBMIT_EVENTS: '25dcr4_MPC9440_enableNewFeedbackSubmitEvents',
    ENABLE_DYNAMIC_FEEDBACK_BUTTON_SIZE: '25dcr2_MPC8565_enableDynamicFeedbackButtonSize',
    DISABLE_USER_PERCENTILE_AT_CREATE_SESSION: '25dcr2_MPC9116_disableUserPercentileAtCreateSession',
    ENABLE_DIGITAL_ANALYTICS: '24dcr1_MPC_7567_enableDigitalFeedbackAnalytics',
    ENABLE_PARTIAL_VIEW: '26dcr2_mpc10177_enablePartialViewMobileWeb',
    ENABLE_SDK_UUID_SUPPORT: '26dcr2_MPC9581_enableSdkUuidSupport',
    ENABLE_AUTO_ADVANCE: '26dcr2_mpc10136_enableAutoAdvanceWeb',
    ENABLE_AUTO_SUBMIT: '26dcr2_mpc10176_enableAutoSubmitWeb',
    ENABLE_ZOOM_FALLBACK: '26dcr1_MPC9581_enableZoomFallback',
    ENABLE_VALIDATIONS_SUMMARY: '26dcr2_mpc9995_enableValidationsSummary'
  },
  MEDALLIA_DIGITAL_EMBED_FILE: 'medallia-digital-embed.js',
  DEFAULT_ADOBE_SDK_NAME: 's',
  // used object instead of array due to major performace differences
  ANALYTICS_EVENT_FORBIDDEN_PROPERTIES: {
    sourceWindow: true,
    content: true,
    feedbackCorrelationUUID: true
  },
  FORM_TRIGGER_TYPES_MAP: {
    embedded: 'Embedded',
    invitation: 'Intercept',
    button: 'AlwaysOn',
    code: 'TriggeredByCode',
  },
  EXPOSED_FEEDBACK_KEYS: {
    FORM_ID_LABEL: 'Form_ID',
    FORM_TYPE_LABEL: 'Form_Type',
    FEEDBACK_UUID_LABEL: 'Feedback_UUID',
    FEEDBACK_CONTENT_LABEL: 'Content',
    FORM_LANGUAGE_LABEL:'Form_Language',
    DIGITAL_UNIT_ID: 'Digital_Unit_ID',
  },
  LANG_MEMORY_DATA_KEY_PREFIX: 'formLanguage:',
  FORM_JSON_DATA_KEY_PREFIX: 'formJsonData:',
  INVITE_JSON_DATA_KEY_PREFIX: 'inviteJsonData:',
  FORM_BUTTON: 'button',
  FORM_INVITATION: 'invitation',
  CUSTOM_EVENT_OTHER: 'Other',
  LOCALIZED_FORM_DEFAULT_REPLACE_VALUE: 'default',
  NOT_RECORDING: 'NOT_RECORDING',
  IFRAME_SETTINGS:{
    EMBEDDED: {
      IFRAME_ID_PREFIX: "embeddedIframe"
    },
    LIGHTBOX:{
      IFRAME_ID_PREFIX:"kampyleForm",
      CONTAINER_ID_PREFIX:"kampyleFormModal",
      WRAPPER_ID: "MDigitalLightboxWrapper"
     },
    ANIMATION:{
      CONTAINER_ID: 'KampyleAnimationContainer',
      IFRAME_ID: 'kampyleFormAnimation',
      WRAPPER_ID: 'MDigitalAnimationWrapper'
    },
    INVITATION: {
      IFRAME_ID: 'kampyleInvite',
      CONTAINER_ID: 'kampyleInviteModal',
      IFRAME_TITLE: 'Invitation to provide feedback',
      WRAPPER_ID: 'MDigitalInvitationWrapper'
    },
    PREVIEW: {
      IFRAME_ID: 'kampyleForm'
    },
    OOPS: {
      CONTAINER_ID_PREFIX: 'mdigital-no-json-modal_',
      CLOSE_BUTTON_ID:'close-no-json-modal'
    },
    IFRAME_TITLE:"Feedback Survey",
    USERSNAP_V4_IFRAME_TITLE: 'Screen Capture'
  },
  IBM_CPS_TO_SEND: {
  testData: true,
  offeringId: true,
  language: true,
  trialUser: true,
  country: true,
  offeringIdShell: true,
  testDataShell: true,
  trialUserShell: true,
  countryShell: true,
  },
  PROPERTY_SETTINGS: {
    MANUALLY_INVITE_TARGETING: 'MANUALLY_INVITE_TARGETING',
    CUSTOM_CSS_UPLOAD: 'CUSTOM_CSS_UPLOAD'
  },
  EVENTS: {
    MDIGITAL_MANUALLY_INVITE_TARGETING: 'MDigital_manuallyInviteTargeting',
    MDIGITAL_PAGE_TARGETING_PHASE_ENDED: 'MDigital_pageTargetingPhaseEnded',
    MDIGITAL_BEHAVIORAL_TARGETING_PHASE_ENDED: 'MDigital_behavioralTargetingPhaseEnded',
    MDIGITAL_QUARANTINED_SURVEY_PHASE_ENDED: 'MDigital_quarantinedSurveyPhaseEnded',
    MDIGITAL_TARGETING_RULE_EVALUATED: 'MDigital_targetingRuleEvaluated',
    MDIGITAL_SCREEN_CAPTURE_LOADED: 'neb_screenCaptureLoaded',
    MDIGITAL_SDK_PAGE_VIEW: 'neb_sdkPageView',
    MDIGITAL_WARNING: 'MDigital_warning',
    MDIGITAL_COULD_NOT_FETCH_DATA: 'MDigital_couldNotFetchData',
    MDIGITAL_COULD_NOT_LOAD_FORM_APPLICATION: 'MDigital_couldNotLoadFormApplication',
    NEB_EVENT_DISPATCHER_ERROR: 'neb_eventDispatcherError',
    NEB_LOAD_FORM: 'neb_loadForm',
    NEB_FORM_LOADING_HAS_FAILED: 'neb_formLoadingHasFailed',
    NEB_RESET_FORM_STATE: 'neb_resetFormState',
    MDIGITAL_DYNAMIC_ONSITE_INITIALIZED_SUCCESSFULLY: 'MDigital_DynamicOnsiteInitializedSuccessfully',
    CREATE_SESSION:'createSession',
    MDIGITAL_NO_JSON_MODAL_SHOWN: 'MDigital_noJsonModalShown',
    MDIGITAL_NO_JSON_MODAL_CLOSED: 'MDigital_noJsonModalClosed',
    MDIGITAL_UPDATE_TARGETING_WITH_DECLINED_DATE_FORM_CLOSED:'MDigital_updateTargetingWithDeclinedDateFormClosed',
    MDIGITAL_UPDATE_TARGETING_WITH_DECLINED_DATE_INVITE_DECLINED:'MDigital_updateTargetingWithDeclinedDateInviteDeclined',
    MDIGITAL_CHTML_LOGS:'MDigital_CHTML_Logs',
    SCREEN_CAPTURE_RETAKE: 'MDigital_screenCaptureRetake',
    SCREEN_CAPTURE_DELETE: 'MDigital_screenCaptureDelete',
    CUSTOM_EVENTS_DEBUG_MESSAGE: 'mdigital_customEventsDebugMessage',
    MDIGITAL_VALIDATE_ORIGIN: 'MDigital_validate_origin',
    DIRECT_GENERIC_INJECTION: 'MDigital_directGenericInjection',
  },
  LOG_MESSAGES: {
    TRIGGER_MESSAGE_TEMPLATE: 'Event {{EVENT_NAME}} has been {{STATUS}}. \n the data is: {{DATA}}. \n the context is :{{CONTEXT}}. \n the options are : {{OPTIONS}}.\n',
    ERROR_LOG_TEMPLATE: 'Error Message is {{ERROR_MESSAGE}}',
    ERROR_DYNAMIC_ONSITE_INITIALIZATION: 'Failed to fetch onsite data.',
    ERROR_ONSITE_SDK_CONFIGURATION_MISSING: 'Failed to execute KAMPYLE_ONSITE_SDK.{{METHOD}}, due to missing onsite configuration.'
  },
  LOG_STATUSES: {
    FAILED: 'failed',
    TRIGGERED: 'triggered'
  },
  OPERATORS: {
    REGEX: 'regex',
    EQUALS: 'equals',
    DOES_NOT_EQUAL: 'doesnotequal',
    CONTAINS: 'contains',
    DOES_NOT_CONTAIN: 'doesnotcontain',
    STARTS_WITH: 'startswith',
    ENDS_WITH: 'endswith',
    HAS_VALUE: 'hasvalue',
    LATER_THAN: 'laterthan',
    EARLIER_THAN: 'earlierthan',
    GREATER_THAN: 'greaterthan',
    SMALLER_THAN: 'smallerthan'
  },
  TARGETING_STATUS: {
    CANDIDACY: 'candidacy',
    TRIGGERED: 'triggered',
    QUARANTINED: 'quarantined'
  },
  TARGETING_PHASES: {
    PAGE_TARGETING: "pageTargeting",
    BEHAVIORAL_TARGETING: "behavioralTargeting",
    QUARANTINE_TARGETING: "quarantineTargeting"
  },
  TARGETING_RULES: {
    INVITE_IF_ANY_SURVEY_ALREADY_SUBMITTED_PER_SESSION: 'InviteAnySurveyAlreadySubmittedPerSession',
    INVITE_IF_ANY_INVITE_ALREADY_SHOWN_PER_SESSION: 'InvitePerSession'
  },
  REGIONS: {
    DEV: 'dev',
    QA: 'qa',
    COLO_QA: 'digital-cloud-qa',
    COLO_US: 'digital-cloud-us',
  },
  MEMORY_DATA_FIELDS: {
    MDIGITAL_ALTERNATIVE_UUID: 'mdigital_alternative_uuid',
    FETCHING_DATA_IN_PROGRESS: 'FETCHING_DATA_IN_PROGRESS_',
    DATA_JSON: 'dataJson',
    HAS_ONSITE_CONFIGURATION: 'hasOnsiteConfiguration',
    SESSION_TAB_PREFIX: 'ONSITE_SESSION_TAB_',
    CURRENT_SESSION_TAB_ID: 'CURRENT_SESSION_TAB_ID',
    TIMEOUT_HANDLERS:'mdTimeoutHandlers', /* TIMEOUT_HANDLERS structure: _memory={ mdTimeoutHandlers: { handlerKey_formId: handlerInstance } } */
    FEEDBACK_CORRELATION_UUID: 'feedbackCorrelationUUID',
    IS_BUTTON_CONTAINER_CREATED: 'isButtonContainerCreated',
    REGION: 'region',
    FEEDBACK_BUTTON_POSITION_STYLE:'buttonPositionStyle',
    LIVE_FORM_V2_DEBUG_MODE: 'md_liveFormV2_isDebugMode',
    DOM_EVENT_HANDLERS: 'domEventHandlers',
    DECIBEL_DATA: 'decibelData',
    EX_AUTHORIZATION_TOKEN: 'md_ex_AuthorizationToken'
  },
  SESSION_DATA_FIELDS: {
    IS_SURVEY_SUBMITTED_IN_SESSION:'md_isSurveySubmittedInSession'
  },
  TIMEOUT_HANDLERS: {
    FORM_APP_STATUS: 'formAppStatus',
    EMBEDDED_STATUS: 'embeddedFormStatus',
  },
  CSS_FONT_RULE: 'CSSFontFaceRule',
  NETWORK: {
    RETRY_TIMEOUT: 1000,
    REQUEST_TIMEOUT: 5000,
    TIME_FOR_FORM_TO_LOAD_MS:60000,
    NUM_OF_RETRIES: 3
  },
  ERROR_CODE: {
    SECURITY_ERROR: 18
  },
  KEY_CODES: {
    SPACE: 32,
    TAB: 9,
    ENTER: 13,
    ESC: 27,
  },
  BROWSERS: {
    IE: 'IE',
    CHROME: 'Chrome',
    FIREFOX: 'Firefox',
    SAFARI: 'Safari'
  },
  MOBILE_SCREEN_WIDTH: 480,
  TEXTS: {
    DEFAULT_JSON_ERROR_MESSAGES: {
      title: 'Oops...',
      body: 'We can’t collect your feedback at the moment.<br/>Refresh your page and try again',
      close: 'Close this modal',
    },
    SCREEN_CAPTURE: {
      DEFAULT_TITLE: 'Screen Capture',
      DEFAULT_DESCRIPTION: 'Click "Capture Image" button or drag the cursor to highlight a specific area'
    }
  },
  FORM_LOADING_FAILURE_CAUSE: {
    APPLICATION_FAILED: 'applicationFailed',
    JSON_FAILED: 'jsonFailed'
  },
  PROPERTY_MESSAGES: {
    NO_JSON_MESSAGE: {
      TYPE: 'noJsonMessage',
      KEYS:{
        TITLE: 'title',
        BODY: 'body',
        CLOSE: 'close'
      }
    }
  },
  BROWSER_EVENTS: {
    FOCUS: 'focus',
    MOUSE_DOWN: 'mousedown'
  },
  SCREEN_CAPTURE: {
    DOM_SELECTION: "DOM_SELECTION",
    DOM_SELECTION_VALUE: "domSelector",
    AREA_SELECTION_VALUE: "highlight",
  },
  ANALYTICS_HTTP_EVENTS_BY_METHOD: {
    BEFORE: {
      POST:'neb_beforeHttpPostRequest'
    },
    AFTER: {
      GET:'neb_afterHttpGetRequest',
      POST:'neb_afterHttpPostRequest'
    },
    TIMEOUT: {
      GET:'neb_afterHttpGetRequestOnTimeout',
      POST:'neb_afterHttpPostRequestOnTimeout'
    },
    ERROR: {
      GET:'neb_afterHttpGetRequestOnError',
      POST:'neb_afterHttpPostRequestOnError'
    },
    ERROR_STATUS_CODE: {
      GET:'neb_afterHttpGetRequestOnErrorStatusCode',
      POST:'neb_afterHttpPostRequestOnErrorStatusCode'
    }
  },
  HTTP_METHODS: {
    GET: 'GET',
    POST: 'POST'
  },
  COLORS: {
    USERSNAP_V4_SELECTION_COLOR: "#fb585b",
    USERSNAP_ONPREM_SELECTION_COLOR: "#004CCB",
    BACKDROP: 'rgba(102,102,102,0.4)',
  },
  VIEW: {
    FEEDBACK_BUTTON_ID: 'nebula_div_btn',
    FEEDBACK_BUTTON_CONTAINER_ID: 'kampyleButtonContainer',
  },
  BUTTON: {
    MAX_WIDTH: 300,
    MIN_HEIGHT: 81,
  },
  CLOSE_FORM_PARAM_VALUES: {
    ALL: 'all',
    EMBEDDED: 'embedded',
    MODAL: 'modal'
  },
  SPINNER_SETTINGS: {
    ID: 'MDigital_spinnerCircle',
    CONTAINER_ID: 'MDigital_spinnerContainer',
    SIZE:{
      LARGE: "large",
      SMALL: "small"
    }
  },
  CSS_SETTINGS: {
    STYLE_SHEET_ANIMATION_NAME: 'MDigital_animationStyle',
    ANIMATION_RULE_SPIN_NAME: 'MDigital_spin'
  }
};
